import React from "react";
import { stats } from "../../data/content";
export function StatStrip() {
  return <section aria-label="Unit at a glance" className="on-light border-y border-navy/10 bg-white" data-id="element-267" data-mp="12bfosm5cjogp">
      <ul className="container-x grid grid-cols-2 gap-px bg-navy/10 px-0 sm:px-0 lg:grid-cols-4 lg:px-0" data-id="element-268" data-mp="neowsxy05f14">
        {stats.map(stat => <li key={stat.label} className="bg-white px-3 py-7 text-center sm:px-4 sm:py-9 lg:py-12" data-id="element-269" data-mp="sc8fqb5nafze">
            <span className="block font-display text-[clamp(2.2rem,4.4vw,3.6rem)] font-extrabold uppercase leading-none text-navy" data-id="element-270" data-mp="ekk1o2bu5hfs">
              {stat.value}
            </span>
            <span className="mt-2.5 block text-[10px] font-bold uppercase leading-snug tracking-[0.14em] text-body sm:mt-3 sm:text-[12px] sm:tracking-[0.2em]" data-id="element-271" data-mp="4oqiw17iwrpk">
              {stat.label}
            </span>
          </li>)}
      </ul>
    </section>;
}